"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegistry = void 0;
var shared_1 = require("@cian/peperrors/shared");
function getRegistry() {
    var registry = window._cian_mf_registry;
    if (!registry) {
        throw new shared_1.ConfigurationError({
            message: 'window._cian_mf_registry not found',
            domain: 'mf-registry.browser.getRegistry',
        });
    }
    return registry;
}
exports.getRegistry = getRegistry;
//# sourceMappingURL=registry.js.map